import { FILTER_CUSTOM_ID } from '@/constants';

export const reportsTeamTrainingSummary = {
    namespaced: true,

    state: {
        filter: {
            clubId: FILTER_CUSTOM_ID,
            athletes: [],
            tags: [],
            speedIntensities: [],
            hrIntensities: [],
            srIntensities: [],
            focuses: [],
            sessionTypes: [],
            sportGroups: [],
            completedSessions: [],
            hasResults: 1,
            trainingLoadStatuses: []
        }
    },

    getters: {
        filter(state) {
            return state.filter;
        }
    },

    mutations: {
        resetState(state) {
            state.filter = {
                clubId: FILTER_CUSTOM_ID,
                athletes: [],
                tags: [],
                speedIntensities: [],
                hrIntensities: [],
                srIntensities: [],
                focuses: [],
                sessionTypes: [],
                sportGroups: [],
                completedSessions: [],
                hasResults: 1,
                trainingLoadStatuses: []
            };
        },

        setAthletes(state, payload) {
            state.filter.athletes = payload;
        },

        setTags(state, payload) {
            state.filter.tags = payload;
        },

        setSessionTypes(state, payload) {
            state.filter.sessionTypes = payload;
        },

        setSportGroups(state, payload) {
            state.filter.sportGroups = payload;
        },

        setSpeedIntensity(state, payload) {
            state.filter.speedIntensities = payload;
        },

        setHrIntensity(state, payload) {
            state.filter.hrIntensities = payload;
        },

        setSrIntensity(state, payload) {
            state.filter.srIntensities = payload;
        },

        setFocuses(state, payload) {
            state.filter.focuses = payload;
        },

        setCompletedSessions(state, payload) {
            state.filter.completedSessions = payload;
        },

        setSessions(state, payload) {
            state.filter.hasResults = payload;
        },

        setClubId(state, payload) {
            state.filter.clubId = payload;
        },

        setTrainingLoadStatuses(state, payload) {
            state.filter.trainingLoadStatuses = payload;
        },
    }
};

export default reportsTeamTrainingSummary;
